document.addEventListener("DOMContentLoaded" ,function(){
    var stickys = document.getElementsByClassName("sticky")
    Array.from(stickys).forEach(sticky => {
      sticky.setAttribute("top", sticky.getBoundingClientRect().top)
    })
    window.addEventListener("scroll", function(){
        Array.from(stickys).forEach(sticky => {
            var parentNode = sticky.parentNode
            if(window.scrollY > sticky.getAttribute("top") + parentNode.offsetHeight - sticky.offsetHeight){
                sticky.style.position = "fixed"
                sticky.style.top = "calc(" + sticky.offsetHeight + "px + var(--header-height))"
                sticky.style.width = "calc(100vw - 50px)"
            }else{
                sticky.style.position = "relative"
                sticky.style.width = ""
                sticky.style.top = "0"
            }
        });
    })
});